import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

const TabNavigation = (props) => {
  const { activeTab, tabs, onGoToTab } = props;

  const handleChangeTab = useCallback(
    (event, newValue) => {
      onGoToTab(newValue);
    },
    [onGoToTab]
  );

  if (!activeTab) return null;

  return (
    <Tabs value={activeTab?.slug} onChange={handleChangeTab} centered>
      {tabs.map((tab) => (
        <Tab key={tab.slug} value={tab.slug} label={tab.label} />
      ))}
    </Tabs>
  );
};

TabNavigation.propTypes = {
  tabs: PropTypes.array,
  activeTab: PropTypes.object,

  onGoToTab: PropTypes.func,
};

TabNavigation.defaultProps = {
  tabs: [],
  activeTab: undefined,
  onGoToTab() {},
};

export default TabNavigation;
